import React, { useEffect, useState } from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { checkFilterItem, fetchFilterData } from "../../../../utils/fetchFilterData";
import { Helmet } from "react-helmet-async";
import userAuthenticationConfig from "../../../../utils/userAuthenticationConfig";
import Notification from "../../../elements/notification/Notification";
import MaterialPagination from "../../../styles/materialPagination";
import WalletWhitelistList from "./WalletWhitelistList";
import ItemsPerPageSelect from "../../../elements/filter/ItemsPerPageSelect";
import WalletWhitelistFilter from "./WalletWhitelistFilter";
import FilterAppliedList from "../../../elements/filter/FilterAppliedList";
import DialogModal from "../../../elements/dialogModal/DialogModal";
import TwoFa from "../../../elements/twoFa/TwoFa";
import { check2FA } from "../../../../utils/check2FA";
import getUserInfo from "../../../../utils/getUserInfo";
import { useTranslation } from "react-i18next";
import { itemsPerPageValue } from "../../../../utils/ItemsPerPageValue";

import { StyledContentWrapper } from "../../../styles/styledMain";
import { StyledWalletWhitelistWrapper } from "../../../walletWhitelist/styledWalletWhitelist";
import { HTTP_STATUSES } from "../../../../utils/consts";

const WalletWhitelistContainer = ({ match }) => {
  const { t } = useTranslation("walletWhitelistPage");

  const [walletMainWhitelist, setWalletMainWhitelist] = useState(null);
  const [totalPageCount, setTotalPageCount] = useState(null);
  const [error, setError] = useState({});

  const [openDelete, setOpenDelete] = useState(false);
  const [deleteSubmitData, setDeleteSubmitData] = useState({
    id: null
  });

  const [openActivity, setOpenActivity] = useState(false);
  const [activitySubmitData, setActivitySubmitData] = useState({
    id: null,
    isActive: false
  });

  const [openApproved, setOpenApproved] = useState(false);
  const [approvedSubmitData, setApprovedSubmitData] = useState({
    id: null,
    isApproved: false
  });

  const history = useHistory();

  const [filterData, setFilterData] = useState({
    "page": checkFilterItem(history, "page", 1, true),
    "itemsPerPage": checkFilterItem(history, "itemsPerPage", itemsPerPageValue(), true),
    "currentTab": checkFilterItem(history, "currentTab", "walletWhitelist", false, true),
    "currency": checkFilterItem(history, "currency", null),
    "paymentSystem": checkFilterItem(history, "paymentSystem", null),
    "wallet": checkFilterItem(history, "wallet", null)
  });

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  const fetchWalletMainWhitelist = () => {
    let filterUrl = fetchFilterData(filterData);
    history.replace(filterUrl);

    axios.get("/api/wallet-user-white-lists" + filterUrl + "&user.id=" + match.params.id, userAuthenticationConfig()).then(response => {
      if (response.status === 200) {
        setWalletMainWhitelist(response.data["hydra:member"]);
        setTotalPageCount(response.data["hydra:totalPageCount"]);
      }
    }).catch(error => {
      setNotification({ ...notification, visible: true, type: "error", message: error.response.data.message });
    });
  };

  const handleRemoveWallet = async (event) => {
    event.preventDefault();

    let check2Fa = await check2FA(getUserInfo()["userId"], event.target.twofa.value);

    if (check2Fa.error) {
      setNotification({ ...notification, visible: true, type: "error", message: check2Fa.error });
      return;
    }

    axios.delete("/api/wallet-user-white-lists/" + deleteSubmitData.id, userAuthenticationConfig()).then(response => {
      if (response.status === HTTP_STATUSES.HTTP_NO_CONTENT) {
        setOpenDelete(false);
        setNotification({ ...notification, visible: true, type: "success", message: t("table.deleteMessage") });
      }
    }).catch(error => {
      setOpenDelete(false);
      setNotification({ ...notification, visible: true, type: "error", message: error.response.data.message });
    });
  };

  const handleChangeActivity = async (event) => {
    event.preventDefault();

    let check2Fa = await check2FA(getUserInfo()["userId"], event.target.twofa.value);

    if (check2Fa.error) {
      setNotification({ ...notification, visible: true, type: "error", message: check2Fa.error });
      return;
    }

    axios.patch("/api/wallet/user-whitelist/activity/" + activitySubmitData.id, { isActive: activitySubmitData.isActive }, userAuthenticationConfig()).then((response) => {
      if (response.status === 200 || response.status === HTTP_STATUSES.HTTP_NO_CONTENT) {
        setOpenActivity(false);
        setNotification({ ...notification, visible: true, type: "success", message: t("table.activityMessage") });

      }
    }).catch((error) => {
      setOpenActivity(false);
      setNotification({ ...notification, visible: true, type: "error", message: error.response.data.message });
    });
  };

  const handleApproved = async (event) => {
    event.preventDefault();

    let check2Fa = await check2FA(getUserInfo()["userId"], event.target.twofa.value);

    if (check2Fa.error) {
      setNotification({ ...notification, visible: true, type: "error", message: check2Fa.error });
      return;
    }

    axios.patch("/api/wallet/user-whitelist/approve/" + approvedSubmitData.id, { isApproved: approvedSubmitData.isApproved }, userAuthenticationConfig()).then((response) => {
      if (response.status === 200 || response.status === HTTP_STATUSES.HTTP_NO_CONTENT) {
        setOpenApproved(false);
        setNotification({ ...notification, visible: true, type: "success", message: t("table.approveMessage") });

      }
    }).catch((error) => {
      setOpenApproved(false);
      setNotification({ ...notification, visible: true, type: "error", message: error.response.data.message });
    });
  };

  useEffect(() => {
    fetchWalletMainWhitelist();
  }, [filterData, notification]);

  const onChangePage = (event, page) => {
    setFilterData({ ...filterData, page: page });
  };
  return (
    <>
      <DialogModal
        open={openDelete}
        setOpen={setOpenDelete}
        title={t("table.twoFa")}
        content={<TwoFa
          handleSubmit={handleRemoveWallet}
          error={error}
        />}
      />
      <DialogModal
        open={openActivity}
        setOpen={setOpenActivity}
        title={t("table.twoFa")}
        content={
          <TwoFa
            handleSubmit={handleChangeActivity}
            error={error}
          />
        }
      />
      <DialogModal
        open={openApproved}
        setOpen={setOpenApproved}
        title={t("table.twoFa")}
        content={
          <TwoFa
            handleSubmit={handleApproved}
            error={error}
          />
        }
      />

      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <>
        <Helmet>
          <title>{t("meta.title")}</title>
        </Helmet>
        <StyledWalletWhitelistWrapper>
          <div className="wallet-main-whitelist-head">
            <WalletWhitelistFilter
              filterData={filterData}
              setFilterData={setFilterData}
            />
            <ItemsPerPageSelect
              itemsPerPage={filterData.itemsPerPage}
              setItemsPerPage={(data) => setFilterData({
                ...filterData,
                "itemsPerPage": data,
                page: 1
              })}
            />
          </div>
          <FilterAppliedList
            filterData={filterData}
            setFilterData={setFilterData}
          />
          <WalletWhitelistList
            walletMainWhitelist={walletMainWhitelist}
            setOpenDelete={setOpenDelete}
            deleteSubmitData={deleteSubmitData}
            setDeleteSubmitData={setDeleteSubmitData}
            setOpenActivity={setOpenActivity}
            activitySubmitData={activitySubmitData}
            setActivitySubmitData={setActivitySubmitData}
            setOpenApproved={setOpenApproved}
            approvedSubmitData={approvedSubmitData}
            setApprovedSubmitData={setApprovedSubmitData}
          />
          {totalPageCount > 0 &&
            <MaterialPagination
              count={totalPageCount}
              shape="rounded"
              page={filterData.page}
              onChange={(event, page) => onChangePage(event, page)}
            />}
        </StyledWalletWhitelistWrapper>
      </>
    </>
  );
};

export default WalletWhitelistContainer;